import React from 'react';
import config from '@config';
import { FunctionComponent } from 'react';
import BaseButton from '@components/common/BaseButton';

interface HomePromoBoxProps
{

}

const HomePromoBox: FunctionComponent<HomePromoBoxProps> = (props) =>
{
    /** Render */
    return (
        <div className="home-promo h-100 w-100 bg-primary base-box d-md-flex flex-column">
            <div className="home-promo-top flex-grow-1">
                <div className="home-promo-title mb-1">Plătiți achizițiile prin rate!</div>
                <div className="home-promo-subtitle mb-3">Finanțare 100% online</div>
            </div>
            
            <div className="home-promo-bottom row align-items-center">
                <div className="col">
                    <BaseButton 
                        text="Aflați mai multe"
                        className="bg-white text-body"
                        width={100}
                        href={config.appUrl + 'plata-in-rate-prin-tbi-finantare-100-online'}
                    />
                </div>
            </div>
        </div>
    );
}

export default HomePromoBox;